import { useEffect, useState, useRef } from 'react'
import Loader from 'react-loaders'
import emailjs from '@emailjs/browser'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import { MapContainer, Marker, Popup } from 'react-leaflet'
import { createTileLayerComponent } from '@react-leaflet/core'
import L from 'leaflet'
import '@maplibre/maplibre-gl-leaflet'

import mapStyle from './mapStyle.json'


const createVectorTileLayer = (props, context) => {
  const instance = L.maplibreGL({
    style: mapStyle,
    pixelRatio: window.devicePixelRatio || 1,
    ...props
  })
  return { instance, context }
}

const updateVectorTileLayer = (instance, props, prevProps) => {
  if (props.style !== prevProps.style) {
    if (instance.getMaplibreMap) {
      instance.getMaplibreMap().setStyle(props.style);
    }
  }
}

const VectorTileLayer = createTileLayerComponent(
  createVectorTileLayer,
  updateVectorTileLayer
)

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const refForm = useRef()

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        refForm.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          alert('Message successfully sent!')
          window.location.reload(false)
        },
        (err) => {
          console.error('EmailJS error:', err)
          alert('Failed to send the message, please try again. Error: ' + err.text)
        }
      )
  }

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I am interested in freelancing & project collaborations - especially
            research assistance. However, if you have any other requests or
            questions, don't hesitate to contact me using below form either.
          </p>
          <div className="contact-form">
            <form ref={refForm} onSubmit={sendEmail}>
              <input type="hidden" name="to_name" value="Chaitanya" />
              <ul>
                <li className="half">
                  <input placeholder="Name" type="text" name="from_name" required />
                </li>
                <li className="half">
                  <input
                    placeholder="Email"
                    type="email"
                    name="reply_to"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="SEND ME" />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          Chaitanya Sirivuri,
          <br />
          Stony Brook University,
          <br />
          Stony Brook, New York
          <br />
          <span className="mail">chaitanyasirivuri@gmail.com</span>
        </div>
        <div className="map-wrap">
          <MapContainer
            center={[40.9132, -73.1261]}
            zoom={15}
            scrollWheelZoom={true}
          >
            <VectorTileLayer />
            <Marker position={[40.9132, -73.1261]}>
              <Popup>Let's have some coffee.</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}
export default Contact
